import { Popover } from "@msuite/ui/popover";
import { useQuery } from "@msuite/ui/query";
import { Skeleton } from "@msuite/ui/skeleton";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";
import { ContactPopover } from "../popovers/contact-popover";

/** Props Interface */
interface ContactProps {
	contactId: string | null;
}

export function Contact({ contactId }: ContactProps) {
	/** Hooks */

	/** Query */
	const { data: contact } = useQuery({
		queryKey: ["contacts", contactId],
		queryFn: async () => {
			if (!contactId) return null;
			const response = await client.contacts[":contactId"].$get({
				param: { contactId },
			});
			const data = await responseHandler(response);
			return data.contact;
		},
	});

	/** Guard */
	if (!contactId) return null;
	if (!contact) return <Skeleton placeholder="Muster Gerüstbau GmbH" />;

	/** Render */
	return (
		<Popover
			trigger="click"
			render={() => <ContactPopover clientId={contactId} />}
		>
			<p>{contact.name}</p>
		</Popover>
	);
}
